import { GlobalResponseObject } from "@schemax-whatsapp/shared-models/common";
import { ContactsInfoModel } from "./contacts-info.model";


export class ContactsInfoResponse extends GlobalResponseObject {
    data?: ContactsInfoModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ContactsInfoModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}